import { AppState } from '@/redux/helper';

import { getCookie, setCookie } from './cookie';

export const VISITED_HABITAT_IDS_COOKIE = 'zlVisitedHabitatIds';
const VISITED_HABITATS_MAX = 20;
const VISITED_HABITATS_EXPIRY_DAYS = 365;

const parseVisitedHabitatIds = (raw: string | undefined): string[] => {
  if (!raw) {
    return [];
  }
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.filter((id): id is string => typeof id === 'string' && id.length > 0);
  } catch {
    return [];
  }
};

export const getVisitedHabitatIds = (): string[] => {
  return parseVisitedHabitatIds(getCookie(VISITED_HABITAT_IDS_COOKIE));
};

const writeVisitedHabitatIds = (ids: string[]) => {
  setCookie(VISITED_HABITAT_IDS_COOKIE, JSON.stringify(ids), { expires: VISITED_HABITATS_EXPIRY_DAYS });
};

export const recordVisitedHabitats = (habitatIds: Array<string | undefined | null>) => {
  const validIds = new Set(habitatIds.filter((id): id is string => !!id));
  if (validIds.size === 0) {
    return;
  }

  const ids = getVisitedHabitatIds();
  const next = ids.filter((id) => !validIds.has(id));
  next.push(...Array.from(validIds));

  writeVisitedHabitatIds(next.slice(-VISITED_HABITATS_MAX));
};

export const recordVisitedHabitat = (habitatId: string | undefined | null) => {
  if (!habitatId) {
    return;
  }
  recordVisitedHabitats([habitatId]);
};

export const recordUtmHabitatFromSearchParams = (search = typeof window !== 'undefined' ? window.location.search : '') => {
  const utmHabitat = new URLSearchParams(search).get('utm_habitat');
  if (utmHabitat) {
    recordVisitedHabitat(utmHabitat);
  }
};

export const getMostRecentOnlineVisitedHabitat = (state: AppState) => {
  const visitedIds = getVisitedHabitatIds();
  if (visitedIds.length === 0) {
    return undefined;
  }

  const onlineHabitatsById = new Map(
    state.allHabitats.filter((habitat) => habitat.online).map((habitat) => [habitat._id, habitat]),
  );

  for (let i = visitedIds.length - 1; i >= 0; i -= 1) {
    const habitat = onlineHabitatsById.get(visitedIds[i]);
    if (habitat) {
      return habitat;
    }
  }

  return undefined;
};

export const getMostRecentOnlineVisitedHabitatId = (state: AppState): string | undefined =>
  getMostRecentOnlineVisitedHabitat(state)?._id;
